import React, { useState } from 'react'
import {
  Col,
  Panel,
  Row,
  Button,
  Icon,
  Message,
  ButtonToolbar,
  Whisper,
  Tooltip,
  Modal,
  Input,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import FollowAuditIssuesForm from './FollowAuditIssuesForm'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'

import ConfirmWidget from '../../confirm/ConfirmWidget'

import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG, SAVE_FAILED_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { sessionRemoveItem } from '../../../utils/sessionHelpers'
import { useHistory } from 'react-router-dom'
import { downloadFile } from '../../../utils/fileUtil'
import pathname from '../../../constants/pathname'
import { convertFollowAuditIssues } from '../reportsAuditWidgets/AuditConvertDataUtil'
import {
  sendBackReportsAudit,
  sendBackReviewIAAudit,
  updateReviewIaAudit,
} from '../../../redux/actions/reportsAudit'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import {
  downloadAuditIAp10,
  downloadAuditIAp12Pdf,
} from '../../../redux/actions/auditReportSummary'
import AlertWidget from '../../confirm/AlertWidget'
import EditButton from '../../../components/buttons/editButton/EditButton'
import { isEmpty } from 'lodash-es'
import ShowLimitLength from '../../../components/utils/ShowLimitLength'

export default function FollowAuditIssuesWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [msgError, setMsgError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isEnableEdit, setIsEnableEdit] = useState()
  const [requestBody, setRequestBody] = useState()
  const [isShowConfimModal, setIsShowConfimModal] = useState(false)
  const [isSaveDraft, setIsSaveDraft] = useState(false)
  const [isShowAlert, setIsShowAlert] = useState(false)

  const [isShowSendBack, setIsShowSendBack] = useState(false)
  const [sendbackNote, setSendbackNote] = useState()
  const [isRefash, setIsRefash] = useState(false)

  let history = useHistory()

  //const auditInfo = sessionGetItemObj('auditInfo')
  //const projectId = sessionStorage.getItem('projectId')

  const onSubmit = (data) => {
    console.log('data => ', data)

    // console.log('99999 => ', !getValues('validApproveOption'))

    if (data.approveOption == 1 && getValues('validApproveOption')) {
      setMsgError('ผลการติดตามการดำเนินรายประเด็นไม่สอดคล้องกับความเห็นโดยสรุปเพื่อเสนออนุมัติ')
      setIsShowAlert(true)

      return false
    } else if (data?.approveOption == 4) {
      setMsgError('ยืนยันการส่งบันทึกความเห็นต่างเพื่อให้ผู้จัดการวินิจฉัยชี้ขาด')
    } else {
      setMsgError('')
    }

    const request = convertFollowAuditIssues(data, formSchema?.form?.id)

    request.append('IsUser', formSchema?.auditRole?.isUser ? true : false)

    if (request) {
      setIsSaveDraft(false)
      setIsShowConfimModal(true)
      setRequestBody(request)
    }
  }

  const onSubmitDraft = () => {
    var data = {}
    //clear error all input
    for (const key in getValues()) {
      Object.assign(data, { [`${key}`]: getValues(key) })
      clearErrors(key)
    }
    console.log('dataTest==>', data)

    const request = convertFollowAuditIssues(data, formSchema?.form?.id)
    request.append('IsUser', formSchema?.auditRole?.isUser ? true : false)

    if (data?.coordinatorComment == 4) {
      setMsgError('ยืนยันการส่งบันทึกความเห็นต่างเพื่อให้ผู้จัดการวินิจฉัยชี้ขาด')
    } else {
      setMsgError('')
    }

    if (request) {
      setIsSaveDraft(true)
      setIsShowConfimModal(true)
      setRequestBody(request)
    }
  }

  const handleSaveAllConfirmModal = async () => {
    startLoading()
    setIsLoading(true)
    try {
      let response = await updateReviewIaAudit(formSchema?.form?.id, requestBody, isSaveDraft)
      console.log('response ', response)
      if (response) {
        setFormSchema(response.model)
        setValue(formSchema?.form?.attachFiles?.name, [])
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setRequestBody()
        // setIsShowConfimModal(false)
        // history.push(`${pathname.proposal.overview.overviewCoworker}`)

        onRefash()
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        // title: SAVE_FAILED_MSG,
        title: e?.response?.data?.errors?.message || SAVE_FAILED_MSG,
      })

      // setIsShowConfimModal(false)
    }
    setIsShowConfimModal(false)
    setIsLoading(false)
    setIsSaveDraft(false)
    doneLoading()
  }

  const handleCancel = () => {
    console.log('handleCancel')
    sessionRemoveItem('auditInfo')

    history.push(`${pathname.proposal.overview.overviewCoworker}`)
  }

  const handleOnSubmitDraftOne = () => {
    // console.log('handleOnSubmitDraftOne ', data)

    onSubmitDraft()
  }

  const handleDownloadIAp10 = async () => {
    // console.log('handleDownloadIAp10 ')

    setIsLoading(true)
    startLoading()
    try {
      const file = await downloadAuditIAp10(
        formSchema?.form?.id || '',
        '' || formSchema?.projectInfo?.id
      )

      if (file) {
        downloadFile(file, file.name || `รายงานตรวจสอบภายใน_IAp10`)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDownloadIAp12 = async (path) => {
    // console.log('handleDownloadIAp12 ')

    setIsLoading(true)
    startLoading()
    try {
      const file = await downloadAuditIAp12Pdf(path)

      if (file) {
        downloadFile(file, file.name || `รายงานตรวจสอบภายใน_IAp12`)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      // console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleSendBack = async (request) => {
    startLoading()
    setIsLoading(true)
    try {
      let response = await sendBackReviewIAAudit(request)
      // console.log('response ', response)
      if (response?.model) {
        setFormSchema(response.model)

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setSendbackNote('')
        setIsShowSendBack(false)

        onRefash()
      } else {
        notification.open('error', {
          title: SAVE_FAILED_MSG,
        })
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: SAVE_FAILED_MSG,
      })

      setIsShowSendBack(false)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSendBack = () => {
    var request = {
      id: formSchema?.form?.id,
      comment: sendbackNote,
    }

    handleSendBack(request)
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={''} bordered>
        {isLoading && <OverlayLoader />}

        {/* <InfoReportsAudit
          schema={formSchema?.projectInfo}
          showButton={false}
          comments={formSchema?.form?.comments}
        /> */}

        {!isRefash && (
          <>
            {formSchema?.form?.comments?.map((item, index) => {
              return (
                <Row key={index}>
                  <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
                    {item?.actor}
                  </Col>
                  <Col lg={18} md={18} sm={24} xs={24}>
                    <Message
                      type="warning"
                      style={{ marginBottom: 10 }}
                      description={
                        <div>
                          {item?.selected && (
                            <>
                              <u>{`${item?.selected}`}</u>
                              <br />
                            </>
                          )}

                          {`ความเห็นเพิ่มเติม :  ${item?.comment || ''}`}
                          <br />

                          {item?.refReview && (
                            <>
                              อ้างอิงความเห็นนักวิชาการ : <br />
                              {item.refReview?.map((e, i) => {
                                return (
                                  <p key={i} style={{ marginLeft: 20 }}>
                                    - {e}
                                  </p>
                                )
                              })}
                              <br />
                            </>
                          )}

                          {`วันที่ให้ความเห็น :  ${item?.commentDate || ''}`}
                        </div>
                      }
                    />
                  </Col>
                </Row>
              )
            })}

            {formSchema?.form && (
              <FollowAuditIssuesForm
                schema={formSchema?.form}
                projectInfo={formSchema?.projectInfo}
                auditRole={formSchema?.auditRole}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                getValues={getValues}
                setValue={setValue}
                clearErrors={clearErrors}
                setIsEnableEdit={setIsEnableEdit}
                onSubmitDraftOne={handleOnSubmitDraftOne}
                disabled={formSchema?.disabled}
              />
            )}

            <Row style={{ marginTop: 20 }}>
              <ButtonToolbar style={{ textAlign: 'right' }}>
                {/* {formSchema?.form?.iAp12Path && ( */}
                <Whisper
                  placement="top"
                  trigger="hover"
                  speaker={
                    <Tooltip>
                      คลิกเพื่อ <i>ดาวน์โหลดไฟล์ IAp12</i>
                    </Tooltip>
                  }
                >
                  <Button
                    color="blue"
                    appearance="link"
                    disabled={formSchema?.form?.iAp12Path ? false : true}
                    onClick={() => {
                      handleDownloadIAp12(formSchema?.form?.iAp12Path)
                    }}
                  >
                    <Icon icon="download" size="lg" /> IAp12
                  </Button>
                </Whisper>
                {/* )} */}

                <Whisper
                  placement="top"
                  trigger="hover"
                  speaker={
                    <Tooltip>
                      คลิกเพื่อ <i>ดาวน์โหลดไฟล์ IAp10</i>
                    </Tooltip>
                  }
                >
                  <Button
                    color="blue"
                    appearance="link"
                    onClick={() => {
                      handleDownloadIAp10()
                    }}
                  >
                    <Icon icon="download" size="lg" /> IAp10
                  </Button>
                </Whisper>

                {formSchema?.form?.button?.saveButton && (
                  <SaveButton
                    onClick={() => {
                      onSubmitDraft()
                    }}
                    disabled={isLoading}
                  >
                    {formSchema.form.button.saveButton}
                  </SaveButton>
                )}

                {formSchema?.form?.button?.submitButton && (
                  <SaveButton onClick={handleSubmit(onSubmit)}>
                    {formSchema.form.button.submitButton}
                  </SaveButton>
                )}

                {formSchema?.form?.button?.sendbackButton && (
                  <EditButton
                    style={{
                      marginRight: 10,
                      marginBottom: 10,
                    }}
                    icon="reply"
                    onClick={() => {
                      setIsShowSendBack(true)
                    }}
                    children={formSchema.form.button.sendbackButton}
                  />
                )}

                {formSchema?.form?.button?.cancelButton && (
                  <CancelButton
                    onClick={() => {
                      handleCancel()
                    }}
                  >
                    {formSchema.form.button.cancelButton}
                  </CancelButton>
                )}
              </ButtonToolbar>
            </Row>
          </>
        )}
      </Panel>

      <ConfirmWidget
        title={`ยืนยัน`}
        show={isShowConfimModal}
        detail={`ยืนยันการ${isSaveDraft ? formSchema.form.button.saveButton : formSchema?.form?.button?.submitButton || 'บันทึก'}`}
        children={msgError || ''}
        size="sm"
        onCancle={() => {
          setIsSaveDraft(false)
          setIsShowConfimModal(false)
        }}
        onConfirm={handleSaveAllConfirmModal}
      />

      <AlertWidget
        title={`การแจ้งเตือน`}
        show={isShowAlert}
        size="sm"
        useHtmlTag
        detail={<div style={{ padding: 5 }} dangerouslySetInnerHTML={{ __html: msgError || '' }} />}
        onClose={() => {
          setIsShowAlert(false)
        }}
      />

      <Modal
        backdrop="static"
        size="md"
        show={isShowSendBack}
        onHide={() => {
          setSendbackNote('')
          setIsShowSendBack(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>
            <p style={{ paddingTop: '0.5rem' }}>ยืนยัน{formSchema.form.button.sendbackButton}</p>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div style={{ marginTop: 10, marginLeft: 5, marginRight: 5 }}>
            <label className={'required'}>ความเห็น</label>
            <Input
              name="sendbackNote"
              placeholder="ระบุความเห็น จำนวนอักขระไม่เกิน 1,000 อักขระ"
              value={sendbackNote}
              rows={4}
              componentClass="textarea"
              maxLength={1000}
              onChange={(value) => {
                setSendbackNote(value)
              }}
            />
            <ShowLimitLength textLength={sendbackNote?.length || 0} maxLength={1000} />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div>
            <SaveButton onClick={onSendBack} loading={isLoading} disabled={isEmpty(sendbackNote)}>
              ยืนยัน
            </SaveButton>
            <CancelButton
              onClick={() => {
                setSendbackNote('')
                setIsShowSendBack(false)
              }}
            >
              ยกเลิก
            </CancelButton>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}
